import React from "react";
import Select from "react-select";
import { selectMenuStyle } from "aible/CustomStyles/DropdownStyles";
import { customMapper, mapToSelectOption, mapToSelectOptions, selectOnChangeWrapper } from "utils/select";
import NumberIcon from "images/EDG/123.svg";
import CategoryIcon from "images/EDG/abc.svg";
import DateIcon from "images/EDG/DateIcon.svg";
import NumberIconWhite from "images/EDG/123White.svg";
import CategoryIconWhite from "images/EDG/abcWhite.svg";
import DateIconWhite from "images/EDG/DateIconWhite.svg";
import styles from "components/Tiles/Sense/style.module.css";
import { getFilteredContext, getNamedOutput, getNamedOutputs, humanizeType } from "utils/expression";
import { outputIsValidForTarget } from "utils/relation";
const SCALAR_MAPPER = customMapper((s) => String(s));
export const TargetInput = ({ target, onTargetChange, targetValue, onTargetValueChange, context, isRetargeting }) => {
    const targetContext = getFilteredContext(context, outputIsValidForTarget);
    const outputs = getNamedOutputs(targetContext);
    const targetOutput = getNamedOutput(context, target);
    const targetValues = targetOutput?.values ?? [];
    const isSelOutcomeMulticategorical = targetOutput !== undefined && targetOutput.type == "TEXT" && targetValues.length > 2;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.outcomeBodyText }, "What new outcome would you like to evaluate? This is a KPI you would chart on the vertical axis or an outcome a model would predict"),
        React.createElement("div", { className: styles.outcomeReselect },
            React.createElement(Select, { formatOptionLabel: (option, meta) => {
                    const isSelected = Array.isArray(meta.selectValue) &&
                        meta.selectValue.find((selectedOption) => selectedOption.value === option.value);
                    const ICONS = {
                        DATE: isSelected ? DateIconWhite : DateIcon,
                        TEXT: isSelected ? CategoryIconWhite : CategoryIcon,
                        NULL: isSelected ? CategoryIconWhite : CategoryIcon,
                        BOOLEAN: isSelected ? NumberIconWhite : NumberIcon,
                        NUMERIC: isSelected ? NumberIconWhite : NumberIcon
                    };
                    const isMenu = meta?.context === "menu";
                    const optionIcon = ICONS[context[option.value]?.type];
                    return (React.createElement("div", { className: styles.outcomeSelectOption },
                        React.createElement("div", null, option?.label),
                        optionIcon && isMenu ? (React.createElement("img", { src: optionIcon, style: { marginLeft: "auto", width: "20px" }, title: humanizeType(context[option.value].type) })) : (React.createElement(React.Fragment, null))));
                }, value: mapToSelectOption(target), options: mapToSelectOptions(outputs.map((o) => o.name)), onChange: selectOnChangeWrapper(onTargetChange), isDisabled: isRetargeting, styles: selectMenuStyle, isClearable: true })),
        isSelOutcomeMulticategorical && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.outcomeReselect }, "is"),
            React.createElement("div", { className: styles.outcomeReselect },
                React.createElement(Select, { value: SCALAR_MAPPER.map(targetValue ?? undefined), options: SCALAR_MAPPER.mapAll(targetValues), isDisabled: isRetargeting, styles: selectMenuStyle, onChange: selectOnChangeWrapper((x) => onTargetValueChange(x)) }))))));
};
